var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import { idbStorage } from '../store/idbStorage';
export var FLAG_NAMES = ['themes'];
export var useFeatureFlagStore = create()(devtools(persist(function (set, get) { return ({
    themes: false,
    checkFeatureFlag: function (featureFlag) {
        var _a;
        return (_a = get()[featureFlag]) !== null && _a !== void 0 ? _a : false;
    },
    setFeatureFlag: function (featureFlag, value) {
        set(function (state) {
            var _a;
            return (__assign(__assign({}, state), (_a = {}, _a[featureFlag] = value, _a)));
        });
    },
}); }, {
    name: 'feature-flags',
    version: 1,
    storage: idbStorage,
    partialize: function (_a) {
        var themes = _a.themes;
        return ({ themes: themes });
    },
})));
export var FeatureFlagged = function (_a) {
    var featureFlag = _a.featureFlag, children = _a.children;
    var isEnabled = useFeatureFlagStore
        .getState()
        .checkFeatureFlag(featureFlag);
    if (!isEnabled) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
